import SiteLayout from '@/components/feature/SiteLayout';
import { useSeo } from '@/hooks/useSeo';
import { faqs } from '@/mocks/faq';
import HeroSection from './components/HeroSection';
import LiveTicker from './components/LiveTicker';
import HotTopics from './components/HotTopics';
import CategorySection from './components/CategorySection';
import SquadPreview from './components/SquadPreview';
import RecommendSection from './components/RecommendSection';
import TestimonialSection from './components/TestimonialSection';
import FaqSection from './components/FaqSection';
import ContactSection from './components/ContactSection';

const jsonLd = [
  {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: '511群众',
    url: 'https://511qunzhong.space/',
    inLanguage: 'zh-CN',
    description: '511群众抱团吃瓜围观阵地，吃瓜小队蹲点汇总前线动态。',
    potentialAction: {
      '@type': 'SearchAction',
      target: 'https://511qunzhong.space/frontline?keyword={search_term_string}',
      'query-input': 'required name=search_term_string',
    },
  },
  {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: '511群众',
    url: 'https://511qunzhong.space/',
    description: '面向吃瓜围观人群的轻资讯聚合与蹲点记录站点。',
    email: 'hello@511qunzhong.space',
  },
  {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.question,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.answer,
      },
    })),
  },
];

export default function Home() {
  useSeo({
    title: '511群众 - 抱团吃瓜围观前线，吃瓜小队蹲点汇总',
    description:
      '511群众是抱团吃瓜的围观阵地，吃瓜小队蹲点汇总前线动态，整理热门瓜点、网络热榜与现场见闻，想跟上围观节奏、看群众都在关注什么，来这里就能同步最新瓜点。',
    keywords: '511群众,511群众抱团吃瓜,511群众围观前线,511群众吃瓜小队,511群众组团围观,511群众群众蹲点',
    jsonLd,
  });

  return (
    <SiteLayout overlayHeader>
      <HeroSection />
      <LiveTicker />
      <HotTopics />
      <CategorySection />
      <SquadPreview />
      <RecommendSection />
      <TestimonialSection />
      <FaqSection />
      <ContactSection />
    </SiteLayout>
  );
}